import {Box} from "@mui/material";
import SocialItem from "@/src/_types/social-item";
import SocialIcon from "@/src/components/common/_partials/footer/social-icon/social-icon";

export default function SocialBox({socialItems}: { socialItems: SocialItem[] }) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                padding: 2,
                gap: 3.5,
            }}
        >
            {socialItems.map((item, index) => (
                <SocialIcon
                    key={index}
                    item={item}
                />
            ))}
        </Box>
    );
}
